import React, { useCallback, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import { ToastContext } from './ToastContext';

function SlideLeft(props) {
	return <Slide {...props} direction="left" />;
}

export default function ToastProvider({ children }) {
	const [toast, setToast] = useState({ open: false, message: '', severity: 'success', action: null, duration: 6000 });

	// showToast(message, severity = 'success', options = {})
	// options.action: optional ReactNode rendered as the Alert action button
	// options.duration: autoHideDuration in ms; null = no auto-hide
	const showToast = useCallback((message, severity = 'success', options = {}) => {
		setToast({
			open: true,
			message,
			severity,
			action: options.action ?? null,
			duration: options.duration !== undefined ? options.duration : 6000,
		});
	}, []);

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') return;
		setToast(prev => ({ ...prev, open: false }));
	};

	return (
		<ToastContext.Provider value={showToast}>
			{children}
			<Snackbar
				open={toast.open}
				autoHideDuration={toast.duration}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				TransitionComponent={SlideLeft}
				sx={{ top: 'calc(var(--app-header-height) + 8px) !important' }}
			>
				<Alert
					onClose={handleClose}
					severity={toast.severity}
					variant="filled"
					action={toast.action}
					sx={{
						minWidth: 320,
						minHeight: 56,
						fontSize: '1.1rem',
						alignItems: 'center',
						boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
					}}
				>
					{toast.message}
				</Alert>
			</Snackbar>
		</ToastContext.Provider>
	);
}
